import { Tag, TagCloseButton, TagLabel } from "@chakra-ui/react";

export default function Chip({
  label,
  onClose,
}: {
  label: string;
  onClose?: () => void;
}) {
  return (
    <Tag
      size="lg"
      borderRadius="md"
      variant="solid"
      backgroundColor={"rgba(183, 227, 252, 0.32)"}
    >
      <TagLabel fontWeight={200} color="#086AA9" pt={1}>
        {label}
      </TagLabel>
      {onClose && <TagCloseButton color="#086AA9" onClick={onClose} />}
    </Tag>
  );
}
